import axios from './axios'
import qs from 'qs';

let adsBastUrl = '/api/amazonAdvertising/';
/**
 * requestType
 * group 广告组
 * activity 广告活动
 *
 */

export default {
  // 广告管理列表
  getCampaignList(data) {
    return axios.get(adsBastUrl + 'getCampaignList', data);
  },

  // 更新广告活动状态
  updateProductStatusBySku(data) {
    return axios.post(adsBastUrl + 'updateProductStatusBySku', qs.stringify(data));
  },

  // 更新广告活动状态
  updateCampaignStatusAndBudgetAndBid(data) {
    return axios.post(adsBastUrl + 'updateCampaignStatusAndBudgetAndBid', qs.stringify(data));
  },

  // TODO 广告活动

  // 获取广告位列表
  getCampaignPlacementList(data) {
    return axios.get(adsBastUrl + 'getCampaignPlacementList', data);
  },

  // 修改广告位竞价调整
  updateAdCampaignsBiding(data) {
    console.log(data);
    return axios.post(adsBastUrl + 'updateAdCampaignsBiding', qs.stringify(data));
  },

  // 竞价修改
  updateDefaultBidList(data) {
    return axios.post(adsBastUrl + 'updateDefaultBidList', qs.stringify(data));
  },

  // TODO 广告组

  // 投放列表
  getAdGroupTargetingList(data) {
    return axios.get(adsBastUrl + 'getAdGroupTargetingList', data);
  },

  // 新增投放
  insertAdGroupTarget(data) {
    return axios.post(adsBastUrl + 'insertAdGroupTarget', qs.stringify(data));
  },

  // 广告组设置-投放修改
  updateAdGroupTarget(data) {
    return axios.post(adsBastUrl + 'updateAdGroupTarget', qs.stringify(data));
  },

  // 广告组 -》修改关键词投放
  updateKeyWord(data) {
    return axios.post(adsBastUrl + 'updateKeyWord', qs.stringify(data));
  },

  // 创建广告组搜索词
  insertKeywords(data) {
    return axios.post(adsBastUrl + 'insertKeywords', qs.stringify(data));
  },

  // 删除广告组搜索词
  deleteKeywords(data) {
    return axios.post(adsBastUrl + 'deleteKeywords', data);
  },

  // 获取广告组关键词列表
  getAdGroupKeywordList(data) {
    return axios.get(adsBastUrl + 'getAdGroupKeywordList', data);
  },

  // 获取广告组搜索词列表
  getSearchItemList(data) {
    return axios.get(adsBastUrl + 'getSearchItemList', data);
  },

  //获取广告组SKU列表
  getSkuList(data) {
    return axios.get(adsBastUrl + 'getAdGroupProductRelationSKUList', data);
  },

  // 编辑广告组sku状态
  updateSkuStatus(data) {
    return axios.post(adsBastUrl + 'updateAdGroupProductRelation', qs.stringify(data));
  },

  // TODO global
  // 获取否定关键词列表
  getNegativeKeywordList(data) {
    if (data.requestType == 'activity') {
      delete data.requestType;
      return axios.get(adsBastUrl + 'getCampaignNegativeKeywordList', data);
    }
    if (data.requestType == 'group') {
      delete data.requestType;
      delete data.params.campaignId;
      return axios.get(adsBastUrl + 'getAdGroupNegativeKeywordList', data);
    }
  },

  // 增加否定搜索词
  insertNegativeKeywords(data) {
    if (data.requestType == 'activity') {
      delete data.requestType;
      return axios.post(adsBastUrl + 'insertAdCampaignsNegativeKeywords', qs.stringify(data));
    }
    if (data.requestType == 'group') {
      delete data.requestType;
      return axios.post(adsBastUrl + 'insertAdGroupNegativeKeywords', qs.stringify(data));
    }
  },

  // 删除否定搜索词
  deleteNegativeKeywords(data) {
    if (data.requestType == 'activity') {
      delete data.requestType;
      return axios.post(adsBastUrl + 'deleteAdCampaignsNegativeKeywords', qs.stringify(data));
    }
    if (data.requestType == 'group') {
      delete data.requestType;
      return axios.post(adsBastUrl + 'deleteAdGroupNegativeKeywords', qs.stringify(data));
    }
  },

  // 根据sku 创建所有的广告活动
  createCampaignByAsin(data) {
    return axios.post(adsBastUrl + 'createCampaignByAsin', qs.stringify(data));
  },

  // 获取否定商品列表
  getNegativeProductList(data) {
    if (data.requestType == 'activity') {
      delete data.requestType;
      return axios.get(adsBastUrl + 'getCampaignNegativeProductList', data);
    }
    if (data.requestType == 'group') {
      delete data.requestType;
      delete data.params.campaignId;
      return axios.get(adsBastUrl + 'getAdGroupNegativeProductList', data);
    }

  },

  // // 编辑广告活动否定商品 暂无
  // updateAdCampaignsBiding(data) {
  //     if(data.requestType == 'activity'){
  //         delete data.requestType;
  //         return axios.post(adsBastUrl + 'updateAdCampaignsBiding', qs.stringify(data));
  //     }
  //     // if(data.requestType == 'group'){
  //     //     delete data.requestType;
  //     //     return axios.post(adsBastUrl + 'updateAdCampaignsBiding', qs.stringify(data));
  //     // }
  // },

  // 新增否定商品
  insertNegativeProduct(data) {
    if (data.requestType == 'activity') {
      delete data.requestType;
      return axios.post(adsBastUrl + 'insertCampaignNegativeProduct', qs.stringify(data));
    }
    if (data.requestType == 'group') {
      delete data.requestType;
      return axios.post(adsBastUrl + 'insertAdGroupNegativeProduct', qs.stringify(data));
    }
  },

  // 删除否定商品
  deleteNegativeProduct(data) {
    if (data.requestType == 'activity') {
      delete data.requestType;
      return axios.post(adsBastUrl + 'deleteCampaignNegativeProduct', qs.stringify(data));
    }
    if (data.requestType == 'group') {
      delete data.requestType;
      return axios.post(adsBastUrl + 'deleteAdGroupNegativeProduct', qs.stringify(data));
    }
  },

  // 广告异常列表
  getAdvertingErrorLog(data) {
    return axios.get(adsBastUrl + 'getAdvertingErrorLog', {
      params: data
    });
  },

  // 批量修改广告组关联商品状态
  updateAdGroupTargetListByAdGroupId(data) {
    return axios.get(adsBastUrl + 'updateAdGroupTargetListByAdGroupId', {
      params: data
    });
  },

  // 批量修改广告组关键词状态
  updateKeyWordListByAdGroupId(data) {
    return axios.get(adsBastUrl + 'updateKeyWordListByAdGroupId', {
      params: data
    });
  },
  //修改维护模式
  modifyMaintenanceMode(data) {
    return axios.get(adsBastUrl + 'modifyMaintenanceMode', {
      params: data
    });
  }
}
